
import { defaultLocale, localeOptions } from '../../constants/defaultValues'
import {
  ALL_CATEGORY_FETCH,
  ALL_CATEGORY_FETCH_SUCCESS,
  ALL_CATEGORY_FETCH_FAIL,

  EXTERNAL_CATEGORY_FETCH,
  EXTERNAL_CATEGORY_FETCH_SUCCESS,
  EXTERNAL_CATEGORY_FETCH_FAIL,

  ALL_SUBCATEGORY_FETCH,
  ALL_SUBCATEGORY_FETCH_SUCCESS,
  ALL_SUBCATEGORY_FETCH_FAIL,

  HELP_FETCH,
  HELP_FETCH_SUCCESS,
  HELP_FETCH_FAIL,

  HELP_DETAIL_FETCH,
  HELP_DETAIL_FETCH_SUCCESS,
  HELP_DETAIL_FETCH_FAIL,

  POLICY_LIST_FETCH,
  POLICY_LIST_FETCH_SUCCESS,
  POLICY_LIST_FETCH_FAIL,

  SEARCH_HELP_LIST_FETCH,
  SEARCH_HELP_LIST_FETCH_SUCCESS,
  SEARCH_HELP_LIST_FETCH_FAIL
} from '../actions';
import {
  CHANGE_LOCALE
} from '../actions';

const INIT_STATE = {
  locale: (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale,
  allCategoryLoading: false,
  allCategoryError: '',
  allCategoryList: '',
  externalCategoryLoading: false,
  externalCategoryError: '',
  externalCategoryList: '',
  allSubcategoryLoading: false,
  allSubcategoryError: '',
  allSubcategoryList: '',
  HelpDataLoading: false,
  HelpDataError: '',
  HelpDataList: [],
  HelpDetailDataLoading: false,
  HelpDetailDataError: '',
  HelpDetailDataList: [],
  policyListLoading: false,
  policyListError: '',
  policyListList: [],
  searchHelpListLoading: false,
  searchHelpListError: '',
  searchHelpList: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_LOCALE:
      return { ...state, locale: action.payload };

    /* category */
    case ALL_CATEGORY_FETCH:
      return { ...state, allCategoryLoading: true, allCategoryError: '' };
    case ALL_CATEGORY_FETCH_SUCCESS:
      return { ...state, allCategoryLoading: false, allCategoryList: action.payload, allCategoryError: '' };
    case ALL_CATEGORY_FETCH_FAIL:
      return { ...state, allCategoryLoading: false, allCategoryList: [], allCategoryError: action.payload.message };

    /*external category */
    case EXTERNAL_CATEGORY_FETCH:
      return { ...state, externalCategoryLoading: true, externalCategoryError: '' };
    case EXTERNAL_CATEGORY_FETCH_SUCCESS:
      return { ...state, externalCategoryLoading: false, externalCategoryList: action.payload, externalCategoryError: '' };
    case EXTERNAL_CATEGORY_FETCH_FAIL:
      return { ...state, externalCategoryLoading: false, externalCategoryList: [], externalCategoryError: action.payload.message };


    /* sub category */
    case ALL_SUBCATEGORY_FETCH:
      return { ...state, allSubcategoryLoading: true, allSubcategoryError: '' };
    case ALL_SUBCATEGORY_FETCH_SUCCESS:
      return { ...state, allSubcategoryLoading: false, allSubcategoryList: action.payload, allSubcategoryError: '' };
    case ALL_SUBCATEGORY_FETCH_FAIL:
      return { ...state, allSubcategoryLoading: false, allSubcategoryList: [], allSubcategoryError: action.payload.message };

    /* help */
    case HELP_FETCH:
      return { ...state, HelpDataLoading: true, HelpDataError: '' };
    case HELP_FETCH_SUCCESS:
      return { ...state, HelpDataLoading: false, HelpDataList: action.payload.HelpData, HelpDataError: '' };
    case HELP_FETCH_FAIL:
      return { ...state, HelpDataLoading: false, HelpDataList: [], HelpDataError: action.payload.message };

    /* help detail */
    case HELP_DETAIL_FETCH:
      return { ...state, HelpDetailDataLoading: true, HelpDetailDataError: '' };
    case HELP_DETAIL_FETCH_SUCCESS:
      return { ...state, HelpDetailDataLoading: false, HelpDetailDataList: action.payload.HelpDetailData, HelpDetailDataError: '' };
    case HELP_DETAIL_FETCH_FAIL:
      return { ...state, HelpDetailDataLoading: false, HelpDetailDataList: [], HelpDetailDataError: action.payload.message };

    /* policy */
    case POLICY_LIST_FETCH:
      return { ...state, policyListLoading: true, policyListError: '' };
    case POLICY_LIST_FETCH_SUCCESS:
      return { ...state, policyListLoading: false, policyListList: action.payload.policyList, policyListError: '' };
    case POLICY_LIST_FETCH_FAIL:
      return { ...state, policyListLoading: false, policyListList: [], policyListError: action.payload.message };

    /* search help */
    case SEARCH_HELP_LIST_FETCH:
      return { ...state, searchHelpListLoading: true, searchHelpListError: '' };
    case SEARCH_HELP_LIST_FETCH_SUCCESS:
      return { ...state, searchHelpListLoading: false, searchHelpList: action.payload, searchHelpListError: '' };
    case SEARCH_HELP_LIST_FETCH_FAIL:
      return { ...state, searchHelpListLoading: false, searchHelpList: [], searchHelpListError: action.payload.message };

    default: return { ...state };
  }
}